<template>
  <v-container class="detail-client px-6 pt-4" fluid>
    <v-row align="center" class="detail-client__toolbar">
      <v-col cols="auto" class="py-0">
        <v-breadcrumbs v-if="roleName === 'admin'" class="pl-0 pt-0 breadcrumbs-dense" :items="items" />
      </v-col>
      <v-spacer />
      <v-btn
        color="primary"
        outlined
        class="text-none"
        rounded
        @click="returnDoorphones"
      >
        <v-icon left small>mdi-doorbell-video</v-icon>
        Список домофонов
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="detail-client__card">
          <v-tabs class="detail-client__tabs" show-arrows>
            <template v-for="tab in filterTabs()">
              <v-tab
                v-if="tab.show"
                :key="tab.name"
                :disabled="tab.disabled"
                class="text-none"
              >
                <v-icon left small>{{ tab.icon }}</v-icon>
                {{ tab.name }}
              </v-tab>
              <v-tab-item
                v-if="tab.show"
                :key="tab.name"
                class="tab-item"
              >
                <component v-bind:is="tab.component"
                  :returnClients="() => returnClients()"
                />
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GeneralInfoClient from './components/GeneralInfoClient';
import CallLogClient from './components/CallLogClient';
import TravelLogClient from './components/TravelLogClient';
import CarNumberChangesHistoryClient from './components/CarNumberChangesHistoryClient';
import GuestAccessHistoryClient from './components/GuestAccessHistoryClient';
import ClientTempCodeProvisionHistoryTab from './components/ClientTempCodeProvisionHistoryTab.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'DetailClient',
  props: ['id'],
  data () {
    return {
      disableRoleName: true,
      items: [
        {
          text: 'Список клиентов',
          disabled: false,
          href: '/list-cliens',
        },
        {
          text: 'Клиент',
          disabled: true,
          href: '#',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      client: 'Client/client',
    }),
    hasDoorphones () {
      return this.client && this.client.abonents && this.client.abonents.length > 0;
    },
    hasBarriers () {
      if (!this.client) return false;
      if (this.client.barriers && Array.isArray(this.client.barriers) && this.client.barriers.length > 0) return true;
      if (!this.client.abonents || !this.client.abonents.length) return false;
      return this.client.abonents.some(a =>
        (a.doorphones || []).some(d => d.barriers && d.barriers.length > 0),
      );
    },
    tabs () {
      return [
        {
          name: 'Информация',
          icon: 'mdi-information-outline',
          component: GeneralInfoClient,
          route: 'DetailClientGeneralInfoClient',
          show: true,
          disabled: false,
        },
        {
          name: 'Журнал звонков',
          icon: 'mdi-phone-log',
          component: CallLogClient,
          route: 'DetailClientCallLogClient',
          show: this.roleName === 'admin',
          disabled: !this.hasDoorphones,
        },
        {
          name: 'Журнал проезда ГРЗ',
          icon: 'mdi-car-side',
          component: TravelLogClient,
          route: 'TravelLogClient',
          show: true,
          disabled: !this.hasBarriers,
        },
        {
          name: 'Журнал гос. номеров',
          icon: 'mdi-format-list-numbered',
          component: CarNumberChangesHistoryClient,
          route: 'DetailClientCarNumberChangesHistory',
          show: this.roleName === 'admin',
          disabled: false,
        },
        {
          name: 'Гостевые пропуски',
          icon: 'mdi-account-group-outline',
          component: GuestAccessHistoryClient,
          route: 'DetailClientGuestAccessHistory',
          show: this.roleName === 'admin',
          disabled: false,
        },
        {
          name: 'Журнал универсальных кодов (в разработке...)',
          icon: 'mdi-key-variant',
          component: ClientTempCodeProvisionHistoryTab,
          route: 'DetailClientTempCodeProvisionHistory',
          show: this.roleName === 'admin',
          disabled: true,
        },
      ];
    },
  },
  methods: {
    returnClients () {
      this.$router.push({ name: 'Client' });
    },
    returnDoorphones () {
      this.$router.push({ name: 'Doorphone' });
    },
    filterTabs () {
      return this.tabs.filter(tab => {
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-client {
  &__toolbar {
    margin-bottom: 4px;
  }
  &__card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  &__tabs {
    ::v-deep .v-tab {
      text-transform: none;
      font-weight: 500;
      letter-spacing: normal;
    }
    ::v-deep .v-tabs-slider {
      border-radius: 2px 2px 0 0;
    }
  }
}
.breadcrumbs-dense {
  ::v-deep .v-breadcrumbs__item {
    font-size: 0.875rem;
  }
}
</style>
